import { useContext } from 'react';
import { StyleSheet } from 'react-native';
import { View } from '@shared/components/View';
import { MBButton, MBButtonTheme } from '@shared/components/button';
import { MBImage, MBImageURISource } from '@shared/components/image';
import { MBTextBody1, MBTextH4 } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';

export interface MBEmptyListPlaceholderProps {
  title?: string;
  description?: string;
  image?: MBImageURISource;
  imageTintColor?: string;
  imageSize?: number;
  imagePosition?: 'above' | 'below';
  imageVerticalGap?: number;
  buttonTitle?: string;
  buttonTheme?: MBButtonTheme;
  onButtonPress?(): void;
  testID?: string;
  className?: string;
}

export function MBEmptyListPlaceholder({
  title,
  description,
  image,
  imageTintColor,
  imageSize = grid(24),
  imagePosition = 'above',
  imageVerticalGap = 2,
  buttonTitle,
  buttonTheme = 'outline',
  onButtonPress,
  testID,
  className,
}: MBEmptyListPlaceholderProps) {
  const colors = useContext(ColorThemeContext);

  const imageElement = image && (
    <MBImage
      source={image}
      tintColor={imageTintColor !== undefined ? imageTintColor : colors.highlightActive}
      style={{ height: imageSize, width: '100%' }}
      resizeMode="contain"
    />
  );

  return (
    <View fill center padding={2} testID={testID} className={className}>
      {imagePosition === 'above' && imageElement}
      {imagePosition === 'above' && image && <View paddingTop={imageVerticalGap} />}
      {!!title && (
        <MBTextH4 align="center" color={colors.foregroundActive} style={styles.title}>
          {title}
        </MBTextH4>
      )}
      <View paddingTop={2} />
      {!!description && (
        <MBTextBody1 align="center" color={colors.foregroundInactive} style={styles.description}>
          {description}
        </MBTextBody1>
      )}
      {imagePosition === 'below' && image && <View paddingTop={imageVerticalGap} />}
      {imagePosition === 'below' && imageElement}
      <View paddingTop={2} />
      {!!buttonTitle && !!onButtonPress && (
        <MBButton size="small" theme={buttonTheme} title={buttonTitle} onPress={onButtonPress} />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  title: {
    // @ts-ignore
    textWrap: 'balance',
    maxWidth: grid(60),
  },
  description: {
    // @ts-ignore
    textWrap: 'balance',
    maxWidth: grid(60),
  },
});
